<template>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh"
                      style="min-height: 300px"
                      pulling-text="下拉重新获取数据"
                      loosing-text="释放即可重新加载"
                      loading-text=""
                      success-text="数据获取成功"
                      :disabled="disable_pull_refresh">
        <div v-if="active === 2 && $common.is_weixn()">
            <Wp_open_by_browser></Wp_open_by_browser>
        </div>
        <div v-else>
            <van-sticky :z-index="2001" offset-top="0" >
                <div style="background-color: white;">
                    <div :style="{backgroundColor: '#FFFFFF',width: '100%', height: 'env(safe-area-inset-top)'}"></div>
                    <div style="display: inline-flex">
                        <span style="height: 52px;width: 40px; padding-left: 6px" @click="clickToHome">
                            <div style=" padding-top: 10px; padding-left: 9px">
                                <van-icon class="changelink_icon" name="wap-home-o" size="18"
                                          color="#EE0A24"></van-icon>
                            </div>
                            <div style="text-align: center; margin-top: -8px; padding-left: 2px; color: #EE0A24">首页</div>
                        </span>

                        <div :style="{width: ($common.screenWidth - 40) + 'px', height: '52px'}">
                            <Wp_search_model ref="Wp_search_model" :search-value="search_value"
                                             font-color=""
                                             :common-transparent="$common.transparent"
                                             @clickToSearch="clickToSearch"
                                             @getSearchValue="getSearchValue"
                                             @onSearchShowHistory="onSearchShowHistory"
                            ></Wp_search_model>
                        </div>

                    </div>
                </div>
            </van-sticky>

            <van-tabs v-model="active" sticky :offset-top="52"
                      title-active-color="#219EFF" color="#219EFF"
                      :line-width="($common.screenWidth / 3 - 20) + 'px'"
                      @change="onTabChange">
                <!--                    tab标签高度为44px-->
                <van-tab>
                    <div slot="title">
                        <div style="display: flex">
                            <van-icon name="http://api.wapg.cn/jd_union/logos/101.png"
                                      size="18"
                                      style="margin-top: 4px"
                            />
                            <h3>&nbsp;京东</h3>
                        </div>
                    </div>

                    <Wp_jd_select_base ref="Wp_jd_select_base"
                                       :offset-top="96"
                                       :keywords="keywords_jd"
                                       @onLoad="onLoad"
                                       @clearSearch="clearSearchBox"
                    ></Wp_jd_select_base>
                </van-tab>
                <van-tab v-if="$common.canShowPdd()">
                    <div slot="title">
                        <div style="display: flex">
                            <van-icon name="http://api.wapg.cn/jd_union/logos/102.png"
                                      size="22"
                                      style="margin-top: 2px"
                            />
                            <h3>&nbsp;拼多多</h3>
                        </div>
                    </div>

                    <Wp_pdd_select_base ref="Wp_pdd_select_base"
                                        :offset-top="96"
                                        :keywords="keywords_pdd"
                                        @onLoad="onLoad"
                                        @clearSearch="clearSearchBox"
                    ></Wp_pdd_select_base>
                </van-tab>
                <van-tab v-if="$common.canShowTaobao()">
                    <div slot="title">
                        <div style="display: flex">
                            <van-icon name="http://api.wapg.cn/jd_union/logos/103.png"
                                      size="22"
                                      style="margin-top: 1px"
                            />
                            <h3>&nbsp;淘宝</h3>
                        </div>
                    </div>

                    <Wp_tb_select_base ref="Wp_tb_select_base"
                                       :offset-top="96"
                                       :keywords="keywords_tb"
                                       @onLoad="onLoad"
                                       @clearSearch="clearSearchBox"
                    ></Wp_tb_select_base>
                </van-tab>
            </van-tabs>

<!--            <div v-if="$common.canShowTaobao()">-->
<!--                <div v-if="$common.canShowPdd()">-->
<!--                    <van-tabs v-model="active" sticky :offset-top="52"-->
<!--                              title-active-color="#219EFF" color="#219EFF"-->
<!--                              :line-width="($common.screenWidth / 3 - 20) + 'px'"-->
<!--                              @change="onTabChange">-->
<!--                        &lt;!&ndash;                    tab标签高度为44px&ndash;&gt;-->
<!--                        <van-tab>-->
<!--                            <div slot="title"><h3>京东</h3></div>-->

<!--                            <Wp_jd_select_base ref="Wp_jd_select_base"-->
<!--                                               :offset-top="96"-->
<!--                                               :keywords="keywords_jd"-->
<!--                                               @onLoad="onLoad"-->
<!--                                               @clearSearch="clearSearchBox"-->
<!--                            ></Wp_jd_select_base>-->
<!--                        </van-tab>-->
<!--                        <van-tab>-->
<!--                            <div slot="title"><h3>拼多多</h3></div>-->

<!--                            <Wp_pdd_select_base ref="Wp_pdd_select_base"-->
<!--                                                :offset-top="96"-->
<!--                                                :keywords="keywords_pdd"-->
<!--                                                @onLoad="onLoad"-->
<!--                                                @clearSearch="clearSearchBox"-->
<!--                            ></Wp_pdd_select_base>-->
<!--                        </van-tab>-->
<!--                        <van-tab>-->
<!--                            <div slot="title"><h3>淘宝</h3></div>-->

<!--                            <Wp_tb_select_base ref="Wp_tb_select_base"-->
<!--                                               :offset-top="96"-->
<!--                                               :keywords="keywords_tb"-->
<!--                                               @onLoad="onLoad"-->
<!--                                               @clearSearch="clearSearchBox"-->
<!--                            ></Wp_tb_select_base>-->
<!--                        </van-tab>-->
<!--                    </van-tabs>-->
<!--                </div>-->
<!--                <div v-else>-->
<!--                    <van-tabs v-model="active" sticky :offset-top="52"-->
<!--                              title-active-color="#219EFF" color="#219EFF"-->
<!--                              :line-width="($common.screenWidth / 3 - 20) + 'px'"-->
<!--                              @change="onTabChange">-->
<!--                        &lt;!&ndash;                    tab标签高度为44px&ndash;&gt;-->
<!--                        <van-tab>-->
<!--                            <div slot="title"><h3>京东</h3></div>-->

<!--                            <Wp_jd_select_base ref="Wp_jd_select_base"-->
<!--                                               :offset-top="96"-->
<!--                                               :keywords="keywords_jd"-->
<!--                                               @onLoad="onLoad"-->
<!--                                               @clearSearch="clearSearchBox"-->
<!--                            ></Wp_jd_select_base>-->
<!--                        </van-tab>-->
<!--                        <van-tab>-->
<!--                            <div slot="title"><h3>淘宝</h3></div>-->

<!--                            <Wp_tb_select_base ref="Wp_tb_select_base"-->
<!--                                               :offset-top="96"-->
<!--                                               :keywords="keywords_tb"-->
<!--                                               @onLoad="onLoad"-->
<!--                                               @clearSearch="clearSearchBox"-->
<!--                            ></Wp_tb_select_base>-->
<!--                        </van-tab>-->
<!--                    </van-tabs>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div v-else>-->
<!--                <div v-if="$common.canShowPdd()">-->
<!--                    <van-tabs v-model="active" sticky :offset-top="52"-->
<!--                              title-active-color="#219EFF" color="#219EFF"-->
<!--                              :line-width="($common.screenWidth / 3 - 20) + 'px'"-->
<!--                              @change="onTabChange">-->
<!--                        &lt;!&ndash;                    tab标签高度为44px&ndash;&gt;-->
<!--                        <van-tab>-->
<!--                            <div slot="title"><h3>京东</h3></div>-->

<!--                            <Wp_jd_select_base ref="Wp_jd_select_base"-->
<!--                                               :offset-top="96"-->
<!--                                               :keywords="keywords_jd"-->
<!--                                               @onLoad="onLoad"-->
<!--                                               @clearSearch="clearSearchBox"-->
<!--                            ></Wp_jd_select_base>-->
<!--                        </van-tab>-->
<!--                        <van-tab>-->
<!--                            <div slot="title"><h3>拼多多</h3></div>-->

<!--                            <Wp_pdd_select_base ref="Wp_pdd_select_base"-->
<!--                                                :offset-top="96"-->
<!--                                                :keywords="keywords_pdd"-->
<!--                                                @onLoad="onLoad"-->
<!--                                                @clearSearch="clearSearchBox"-->
<!--                            ></Wp_pdd_select_base>-->
<!--                        </van-tab>-->
<!--                    </van-tabs>-->
<!--                </div>-->
<!--                <div v-else>-->

<!--                    <Wp_jd_select_base ref="Wp_jd_select_base"-->
<!--                                       :offset-top="52"-->
<!--                                       :keywords="keywords_jd"-->
<!--                                       @onLoad="onLoad"-->
<!--                                       @clearSearch="clearSearchBox"-->
<!--                    ></Wp_jd_select_base>-->
<!--                </div>-->
<!--            </div>-->

        </div>

        <van-popup v-model="showElemePop" round :style="{width: $common.screenWidth - 80 + 'px'}"
                   @closed="closeElemePop">
            <div v-if="search_value === '饿了么'" style="font-size: 25px; color: #ffffff; padding: 20px 0px; text-align: center; background-color: #4294F7">
                <div style="font-size: 35px; margin-bottom: 10px">饿了么</div>
                <div><span style="color: #ffff00">抢66元</span>霸王餐红包</div>
                <div>点外卖<span style="color: #ffff00">先领红包</span></div>
                <van-button color="#F19554" round style="width: 110px; margin-top: 10px" @click="jumpToEleme">抢红包
                </van-button>
            </div>

            <div v-if="search_value === '美团'" style="font-size: 25px; color: #8D4016; padding: 20px 0px; text-align: center; background-color: #FFC116">
                <div style="font-size: 35px; margin-bottom: 10px; font-weight: bold">美团</div>
                <!--                <div><span style="color: #ffffff">抢41元</span>外卖红包</div>-->
                <!--                <div>点外卖<span style="color: #ffff00">先领红包</span></div>-->
                <div>外卖红包天天领</div>
                <div>超值优惠享不停</div>
                <van-button color="#ca6027" round style="width: 110px; margin-top: 10px" @click="jumpToMeituan">抢红包
                </van-button>
            </div>

        </van-popup>
<!--        <van-popup v-model="showMeituanPop" round :style="{width: $common.screenWidth - 80 + 'px'}"-->
<!--                   @closed="closeMeituanPop">-->
<!--            <div style="font-size: 25px; color: #8D4016; padding: 20px 0px; text-align: center; background-color: #FFC116">-->
<!--                <div style="font-size: 35px; margin-bottom: 10px; font-weight: bold">美团</div>-->
<!--&lt;!&ndash;                <div><span style="color: #ffffff">抢41元</span>外卖红包</div>&ndash;&gt;-->
<!--&lt;!&ndash;                <div>点外卖<span style="color: #ffff00">先领红包</span></div>&ndash;&gt;-->
<!--                <div>外卖红包天天领</div>-->
<!--                <div>超值优惠享不停</div>-->
<!--                <van-button color="#ca6027" round style="width: 110px; margin-top: 10px" @click="jumpToMeituan">抢红包-->
<!--                </van-button>-->
<!--            </div>-->

<!--        </van-popup>-->
    </van-pull-refresh>
</template>

<script>
    import Wp_jd_select_base from "./Wp_jd_select_base";
    import Wp_search_model from "../custom/Wp_search_model";
    import Wp_pdd_select_base from "../pdd/pages/Wp_pdd_select_base";
    import Wp_tb_select_base from "../tb/pages/Wp_tb_select_base";
    import Wp_nav_bar from "../custom/Wp_nav_bar";
    import Wp_open_by_browser from "../custom/Wp_open_by_browser";
    import {Toast} from 'vant';

    export default {
        name: "Wp_all_search_page",
        components: {
            Wp_open_by_browser,
            Wp_nav_bar, Wp_tb_select_base, Wp_pdd_select_base, Wp_search_model, Wp_jd_select_base},
        data() {
            return {
                search_value: '',
                //下拉刷新结束
                isLoading: false,
                //是否禁用下拉刷新
                disable_pull_refresh: false,

                active: 0,

                keywords_jd: '',
                keywords_pdd: '',
                keywords_tb: '',

                showElemePop: false,
                showMeituanPop: false,
            }
        },

        created() {
            this.initActive();
        },
        mounted() {
            //获取url中的参数search
            //以下逻辑不能放到created中使用，在created中使用，会导致Wp_search_model中的watch监听的searchValue无法被监听到，
            // 应该是created完成后this.search_value才第一次完成创建
            let value = this.$common.getUrlKey("search");
            if (value) {
                let url_param_value = decodeURIComponent(value);
                if (url_param_value) {
                    this.search_value = url_param_value;
                }
            }
            if (this.$common.canShowTaobao()) {
                // let tb_pid = this.$common.getUrlKey('taobao_pid');
                let type = this.$common.getUrlKey('type');
                let oldmark = this.$common.getUrlKey('oldmark');
                if (type && oldmark) {
                    this.active = 2;
                }
            }
        },

        methods: {

            initActive(){
                let _active = this.$common.getUrlKey('active');
                if(_active){
                    this.active = Number(_active);
                }
            },

            jumpToEleme() {
                // Toast.success({
                //     message: '功能维护，预计维护时间30分钟'
                // })
                this.$common.navigateToMiniProgramPage('../wp_eleme/wp_eleme');
            },
            jumpToMeituan() {
                // Toast.success({
                //     message: '功能维护，预计维护时间30分钟'
                // })
                this.$common.navigateToMiniProgramPage('../wp_meituan/wp_meituan');
            },
            closeElemePop() {
                this.$log('-----closeElemePop---------')
                this.showElemePop = false;
            },
            closeMeituanPop() {
                this.$log('-----closeMeituanPop---------')
                this.showMeituanPop = false;
            },

            clickToHome() {
                this.$log("clickToHome")
                this.$router.back();
            },

            clearSearchBox() {
                this.$log('------------------clearSearchBox-------------------')
                // this.$refs.Wp_search_model.search_value = "";
            },

            onTabChange(v) {
                this.active = v;
                if (this.$common.canShowPdd()) {
                    if (this.active === 0) {
                        this.keywords_jd = this.search_value;
                    } else if (this.active === 1) {
                        this.keywords_pdd = this.search_value;
                    } else if (this.active === 2) {
                        this.keywords_tb = this.search_value;
                    }
                } else {
                    if (this.active === 0) {
                        this.keywords_jd = this.search_value;
                    } else if (this.active === 1) {
                        this.keywords_tb = this.search_value;
                    }
                }
                this.$log("this.search_value = " + this.search_value)
            },

            getRef() {
                if (this.$common.canShowPdd()) {
                    if (this.active === 0) {
                        return this.$refs.Wp_jd_select_base;
                    } else if (this.active === 1) {
                        return this.$refs.Wp_pdd_select_base;
                    } else if (this.active === 2) {
                        return this.$refs.Wp_tb_select_base;
                    } else {
                        return this.$refs.Wp_jd_select_base;
                    }
                } else {
                    if (this.active === 0) {
                        return this.$refs.Wp_jd_select_base;
                    } else if (this.active === 1) {
                        return this.$refs.Wp_tb_select_base;
                    } else {
                        return this.$refs.Wp_jd_select_base;
                    }
                }
            },

            /**
             * 根据条件查询数据
             */
            clickToSearch() {
                if(this.$common.all_limit_words.includes(this.search_value.toUpperCase())){
                    this.getRef().initStatus();
                    setTimeout(()=>{
                        this.getRef().$refs.Wp_pull_list.endLoading();
                        this.search_value = '';
                    }, 800);

                    return;
                }

                this.getRef().clickToSearch();
                // this.searchInputClick('0');

                if(this.$store.state.pid){
                    if(this.$config.project === 'mini' || this.$config.project === 'jd_test'){
                        if(this.search_value === '饿了么' || this.search_value === '美团'){
                            this.showElemePop = true;
                        }
                    }
                }
                // if (this.$config.project === 'mini' || this.$config.project === 'jd_test'
                //     && this.search_value === '饿了么' || this.search_value === '美团') {
                //     this.showElemePop = true;
                // }
                // if (this.$config.project === 'mini' || this.$config.project === 'jd_test' && this.$store.state.pid && this.search_value === '美团') {
                //     this.showMeituanPop = true;
                // }
            },

            searchInputClick(id) {
                this.getRef().searchInputClick(id);
            },

            getSearchValue(value) {
                this.search_value = value;
                this.getRef().getSearchValue(value);
            },

            // inputListener(value){
            //     this.search_value = value;
            // },

            /**
             * 下拉刷新
             */
            onRefresh() {
                this.getRef().onRefresh();
            },

            onLoad() {
                //关闭下拉刷新
                this.isLoading = false;
            },

            onSearchShowHistory(event) {
                if (event) {
                    this.disable_pull_refresh = true;
                } else {
                    this.disable_pull_refresh = false;
                }
            },
        }
    }
</script>

<style scoped>

</style>